<template>
  <DrawerVue :refreshDisplay="refreshDisplay">
    <v-container>
      <v-row class="mb-4">
        <v-col cols="12">
          <h2 v-if="dayData">
            {{ $t("basics.edit", { type: $t("basics.holiday") }) }}
          </h2>
          <h2 v-else>
            {{ $t("basics.new", { type: $t("basics.holiday") }) }}
          </h2>
        </v-col>
      </v-row>

      <v-form ref="holidayEditForm">
        <v-row>
          <v-col>
            <v-text-field v-model="startDate" :label="$t('basics.startDate') + '*'" variant="outlined" type="date"
              :min="minStartDate" :max="maxStartDate" placeholder="DD.MM.YYYY"
              :rules="[requiredRule, startDateSmallerRule]"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
              <v-text-field v-model="endDate" :label="$t('basics.endDate') + '*'" variant="outlined" type="date"
              :min="minEndDate" :max="maxEndDate" placeholder="DD.MM.YYYY"
              :rules="[requiredRule, startDateSmallerRule]"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field variant="outlined" flat :rules="[requiredRule, max256]" v-model="comment"
              :label="$t('basics.name') + '*'"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-btn large block flat class="primaryButton" @click="confirm()" ref="confirmButton" style="width: 100%">
              <span>{{ $t("basics.confirm") }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </DrawerVue>
</template>

<script>
export default {
  name: "holidayEditComponent",

  props: ["refreshDisplay", "dayData"],

  emits: ["close"],

  data() {
    return {
      startDate: undefined,
      startDatePicker: false,

      endDate: undefined,
      endDatePicker: false,

      comment: undefined,

      requiredRule: (value) => !!value || this.$i18n.t("messages.required"),
      max256: (value) =>
        !value || value.length <= 256 || this.$i18n.t("messages.tooLong", { count: 256 }),

      validObject: (value) =>
        !value ||
        typeof value == "object" ||
        this.$i18n.t("messages.validSelectionrequired"),

      startDateSmallerRule: (value) =>
        !this.startDate ||
        !this.endDate ||
        this.startDate <= this.endDate ||
        typeof value == "object" ||
        this.$i18n.t("messages.startDateTooBig"),
    };
  },

  watch: {
    refreshDisplay() {
      if (this.refreshDisplay) {
        this.setValues();
      }
    },
  },

  computed: {
    minStartDate(){
      return "2000-01-01"
    },
    maxStartDate(){console.log(this.startDate)      
      return  "9999-12-31"
    },
    minEndDate(){
      if(this.startDate){
        return (new Date(this.startDate)).toISOString().split('T')[0]
      }

      return "2000-01-01"
    },
    maxEndDate(){console.log(this.startDate)      
      return  "9999-12-31"
    }
  },

  methods: {
    setValues() {
      if (this.dayData) {
        this.startDate = this.dayData.start_date;
        this.endDate = this.dayData.end_date;
        this.comment = this.dayData.comment;
      } else {
        this.startDate = undefined;
        this.endDate = undefined;
        this.comment = undefined;
      }
    },
    getReadableDate(date) {
      if (date) return this.$moment(date).format("DD.MM.YYYY");
      else return undefined;
    },
    async confirm() {
      const { valid } = await this.$refs.holidayEditForm.validate();

      if (valid) {
        this.$emit("loading", true);

        let formData = {
          start_date: this.$moment(this.startDate).format("YYYY-MM-DD"),
          end_date: this.$moment(this.endDate).format("YYYY-MM-DD"),
          comment: this.comment,
        };


        if (this.dayData) {
          formData["id"] = this.dayData.id;
          this.patchData(formData);
        } else {
          this.postData(formData);
        }
      }
    },
    postData(formData) {
      this.axios
        .post(this.axios.defaults.baseURL + "calendar/holidays/post/", formData)
        .then((resp) => {
          this.$emit("close", 1);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
    patchData(formData) {
      this.axios
        .patch(
          this.axios.defaults.baseURL + "calendar/holidays/patch/" + formData.id,
          formData
        )
        .then((resp) => {
          this.$emit("close", 1);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
    fetchData() { },
  },

  mounted() {
    this.fetchData();
  },
};
</script>
